import { startOfToday, startOfYesterday } from 'date-fns'

export const getToday = () => startOfToday()
export const getYesterday = () => startOfYesterday()

export const isSnowSeason = (date: Date) => {
  const month = date.getMonth()
  const day = date.getDate()

  if (month === 10) {
    return day >= 28
  }

  if (month === 11) {
    return true
  }

  if (month === 0) {
    return day <= 6
  }

  return false
}
